import React from 'react';
import SearchHouseBank from './searchHouseBank';
import './index.scss';
const HouseBank = () => {
    
    return(<SearchHouseBank/>)
}

export default HouseBank;